// extracted by mini-css-extract-plugin
export default {"scrollDiv":"FeedbackPopup_scrollDiv__rfugX","feedbackText":"FeedbackPopup_feedbackText__hWKwk","underline":"FeedbackPopup_underline__AkN1b","timer":"FeedbackPopup_timer__DOyIA"};